// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceAPIModel
 */
export interface BalanceAPIModel {
    /**
     * 
     * @type {string}
     * @memberof BalanceAPIModel
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceAPIModel
     */
    amount: string;
}

export function BalanceAPIModelFromJSON(json: any): BalanceAPIModel {
    return BalanceAPIModelFromJSONTyped(json, false);
}

export function BalanceAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetId': json['assetId'],
        'amount': json['amount'],
    };
}

export function BalanceAPIModelToJSON(value?: BalanceAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assetId': value.assetId,
        'amount': value.amount,
    };
}


